import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./components/Home";
import ContactUs from "./components/Contact";
import Custom from "./components/Custom";
import Website from "./components/Website";
import Outsourcing from "./components/Outsourcing";
import About from "./components/About";
import Product from "./components/product";

import Hotelsof from "./components/Hotelsof";
import Hospital from "./components/Hospital";
import TeaSof from "./components/Teasof";
import JewSof from "./components/Jewsof";
import Pharma from "./components/Pharma";
import TeaSale from "./components/Teasale";
import Restaurant from "./components/Restaurant";
import Bakery from "./components/Bakery";
import Pathology from "./components/Pathology";
import Transport from "./components/transport";
import PaySof from "./components/paysof";
import NewsSof from "./components/NewsSof";
import EmailContactForm from "./components/EmailContactForm";
import Retails from "./components/retail";

import RequestDemo from "./components/RequestDemo";
import ContactSales from "./components/ContactSales";

import JobOpening from "./components/JobOpening";

const App = () => {
  return (
    <>
      {/* Global Default SEO (homepage / overall site) */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>EBS Software Solution's Official</title>
        <meta
          name="description"
          content="Software Development India, West Bengal, Kolkata, Siliguri | Software Company in India | Software Development West Bengal | Customised Software India | Software for Hotel, Medicine Distributors, Jewellery Shop"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/custom" element={<Custom />} />
        <Route path="/about" element={<About />} />
        <Route path="/website" element={<Website />} />
        <Route path="/outsourcing" element={<Outsourcing />} />

        {/* Products */}
        <Route path="/hotelsof" element={<Hotelsof />} />
        <Route path="/hospital" element={<Hospital />} />
        <Route path="/teasof" element={<TeaSof />} />
        <Route path="/jewsof" element={<JewSof />} />
        <Route path="/pharma" element={<Pharma />} />
        <Route path="/teasale" element={<TeaSale />} />
        <Route path="/restaurant" element={<Restaurant />} />
        <Route path="/bakery" element={<Bakery />} />
        <Route path="/pathology" element={<Pathology />} />
        <Route path="/transport" element={<Transport />} />
        <Route path="/paysof" element={<PaySof />} />
        <Route path="/newssof" element={<NewsSof />} />
        <Route path="/retails" element={<Retails />} />

        {/* Forms */}
        <Route path="/emailcontactform" element={<EmailContactForm />} />

        {/* NEW: TeaSof Landing CTAs */}
        <Route path="/request-demo" element={<RequestDemo />} />
        <Route path="/contact-sales" element={<ContactSales />} />

        {/* Jobs */}
        <Route path="/jobopening" element={<JobOpening />} />
      </Routes>

      <Footer />
    </>
  );
};

export default App;
